import { RouteGuard } from './RouteGuard';
import ErrorComponent from 'features/root/ErrorComponent';
import NotFoundComponent from 'features/root/NotFoundComponent';
import { AuthRoutes } from 'features/auth';
import { RootComponent } from 'features/root/RootComponent';
import { Route, Routes } from 'react-router-dom';
import { lazyImport } from 'framework/utility/LazyImport';
import SSOComponent from 'features/root/SSOComponent';
import NotificationContainer from 'features/EmailPreview/NotificationContainer';

// FEATURE MODULES
const { DashboardComponent } = lazyImport(() => import('../features/root'), 'DashboardComponent');
const { EventManagementRoutes } = lazyImport(() => import('../features/eventManagement'), 'EventManagementRoutes');

export const AppRoutes = () => {
  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="" element={<RootComponent/>} />
      <Route path="/" element={<RootComponent/>} />
      <Route path="/auth/*" element={<AuthRoutes/>} />
      <Route path="/error" element={<ErrorComponent />} />
      <Route path="/sso" element={<SSOComponent/>} />
      {/* FEATURE MODULES - PROTECTED */}
      <Route element={<RouteGuard/>}>
       <Route path='/dashboard/*' element={<DashboardComponent/>}/>
       <Route path='/events/*' element={<EventManagementRoutes/>}/>
      </Route>
      <Route path="/email-preview" element={<NotificationContainer />} />
      <Route path="*" element={<NotFoundComponent />} />
    </Routes>
  )
}